import styled from "styled-components";

export default function HangingCard({ children, dark = false, style }) {
  return (
    <Card dark={dark} style={{ ...style }}>
      {children}
    </Card>
  );
}

const Card = styled.article`
  background-color: #fff;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.4);
  transform-style: preserve-3d;
  position: relative;

  ::after {
    content: "";
    display: block;
    width: 4px;
    height: 4px;
    background-color: ${({ dark }) => (dark ? "#fff" : "#000")};
    border-radius: 50%;
    position: absolute;
    inset: -21px 0;
    margin-inline: auto;
  }

  ::before {
    content: "";
    display: block;
    width: 50px;
    height: 50px;
    border-left: 1px solid;
    border-top: 1px solid;
    border-color: ${({ dark }) =>
      dark ? "rgba(255, 255, 255, 0.5)" : "rgba(0, 0, 0, 0.5)"};
    position: absolute;
    inset: -10px 0;
    margin-inline: auto;
    transform: rotate(45deg) translateZ(-1px);
  }
`;
